export default __webpack_public_path__ + "static/media/DOM-DEC2025.389f8a5f.png";